import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get, values } from 'lodash'
import { change, getFormValues, isDirty } from 'redux-form'

import EventSuiteMenus from '../../components/Suite/Menus'
import { makeGetAttendant, getEventFormRegisteredFields } from '../../store/Staff/selector'
import { makeGetAttendantEventSetting } from '../../store/AppDeviceConfiguration/selector'
import { MENU_TYPES } from '../../utils/menuTypes'
import { getCurrentVenueUuid } from '../../store/Venues/selector'
import {
  createAttendantSetting,
  updateAttendantSetting,
} from '../../store/AppDeviceConfiguration/actions'

const mapStateToProps = (state, ownProps) => {
  const currentVenueUuid = getCurrentVenueUuid(state)
  const eventId = get(ownProps, 'match.params.eventId')
  const staffId = get(ownProps, 'match.params.employeeId')
  const getAttendant = makeGetAttendant()
  const getAttendantEventSetting = makeGetAttendantEventSetting()
  const attendant = getAttendant(state, staffId)
  const allMenuSubTypes = values(MENU_TYPES)

  const attendantSetting = getAttendantEventSetting(state, get(attendant, 'uuid'), eventId)

  const isNewSetting = !attendantSetting
  const menuSubtypes = get(attendantSetting, 'configuration.menuSubtypes', [])
  const attendantMenuSubtypes = menuSubtypes.map(type => MENU_TYPES[type])

  const initialValues = {}
  initialValues['subTypes'] = attendantMenuSubtypes

  const formFields = getEventFormRegisteredFields(state)
  const formValues = getFormValues('attendant-event-settings')(state)
  const formAltered = field => isDirty('attendant-event-settings')(state, [field])
  const formSubTypes = get(formValues, 'subTypes', [])
  return {
    eventId,
    currentVenueUuid,
    attendant,
    allMenuSubTypes,
    attendantMenuSubtypes,
    formSubTypes,
    attendantSetting,
    initialValues,
    isNewSetting,
    formFields,
    formAltered,
    history: ownProps.history
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onFieldValueChange: (field, value) =>
      dispatch(change('attendant-event-settings', field, value)),
    createAttendantSetting: (currentVenueUuid, params) =>
      dispatch(createAttendantSetting(currentVenueUuid, params)),
    updateAttendantSetting: params => dispatch(updateAttendantSetting(params)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventSuiteMenus))
